import React, { Component } from "react";

import ToolsModal from "./ToolsModal";

import "./tools-text-entry-modal.css";

class ToolsTextEntryModal extends Component {
	onTextChange = event => {
		this.props.onTextChange({ text: event.target.value });
	};

	renderFooter() {
		const { text, confirmLabel, isBusy, onCancel, onConfirm } = this.props;
		const hasText = text.trim() !== "";
		return (
			<div className="tk-modal-actions">
				<button type="button" className="tk-button tk-button--secondary" onClick={onCancel}>
					Cancel
				</button>
				<button type="button" className="tk-button tk-button--primary" onClick={onConfirm} disabled={!hasText || isBusy}>
					{confirmLabel}
				</button>
			</div>
		);
	}

	render() {
		const { isOpen, title, width = 560, intro, label, help, text, rows = 6, onCancel } = this.props;
		return (
			<ToolsModal open={isOpen} onClose={onCancel} title={title} width={width} footer={this.renderFooter()}>
				{intro && <p className="tools-text-entry-modal__intro">{intro}</p>}
				<div className="tk-form-field">
					{label && (
						<div className="tk-form-label">
							{label}
							<span className="tk-form-required">*</span>
						</div>
					)}
					<textarea className="tk-input tools-text-entry-modal__text" value={text} onChange={this.onTextChange} rows={rows} autoFocus />
					{help && <div className="tk-form-help">{help}</div>}
				</div>
			</ToolsModal>
		);
	}
}

export default ToolsTextEntryModal;
